import React from 'react';
import {Button, Switch} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

interface MergeContentFormProps {
  checked: boolean;

  label: string;
  disabled: boolean;
  onChange: (value: any) => void;
  onClick: (value: boolean) => void; // Function to open the dialog
}

export const MergeContentForm = ({
  checked,
  onChange,
  onClick,
  label,
  disabled,
}: MergeContentFormProps) => {
  const onChange_ = (event: any) => {
    onChange(event.target.checked);
  }

  return (
    <div className="report-content-options__merge-item">
      <Switch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span>{label}</span>
      <Button
        className="merge-pdf-filename"
        minimal={true}
        small={true}
        icon={IconNames.COG}
        disabled={disabled || !checked}
        onClick={() => onClick(true)}
      />
    </div>
  )
}
